import startPage from "./page/start/StartPage.vue";
import mainPage from "./page/main/MainPage.vue";
import quizPage from "./page/quiz/view/Quiz.vue";
import navLayout from "@/layout/nav/NavLayout.vue";
import policyPage from "./page/policy/PolicyPage.vue";
import {createRouter, createWebHistory} from "vue-router";
import WidgetComponent from "@/widget/WidgetComponent.vue";
import seagull from "@/seagull/App.vue";
import test from "./page/testTest.vue";

const href = window.location.href;
const customDomein = !(
  href.includes("localhost") || href.includes("readds.ru")
);
const routes = [
  {
    path: "/",
    component: mainPage,
    meta: {
      layout: "default"
    }
  },
  {
    path: "/test",
    component: test,
    meta: {
      layout: "default"
    }
  },
  {
    path: "/seagull",
    component: seagull,
    meta: {
      layout: "default"
    }
  },
  {
    path: "/home",
    component: navLayout,
    meta: {
      layout: "navLayout",
      children: "startHomePage",
      navGroup: "home"
    }
  },
  {
    path: "/tariff",
    component: navLayout,
    meta: {
      layout: "navLayout",
      children: "TariffPage",
      navGroup: "tariff"
    }
  },
  {
    path: "/quiz/:id",
    component: quizPage,
    meta: {
      layout: "default",
      navGroup: "quiz"
    }
  },
  {
    path: "/quiz",
    component: navLayout,
    meta: {
      layout: "navLayout",
      children: "quizList",
      navGroup: "quiz"
    }
  },
  {
    path: "/quiz/setting/:id",
    component: navLayout,
    meta: {
      layout: "navLayout",
      children: "quizSetting",
      navGroup: "quiz"
    }
  },
  {
    path: "/quiz/setting/:id/landingPage",
    name: "landingPage",
    component: navLayout,
    meta: {
      layout: "navLayout",
      children: "quizSetting",
      nextChildren: "LandingPage",
      nameNav: "Страница",
      navGroup: "landingPage"
    }
  },
  {
    path: "/quiz/setting/:id/ABTest",
    name: "ABTest",
    component: navLayout,
    meta: {
      layout: "navLayout",
      children: "quizSetting",
      nextChildren: "LandingPage",
      nameNav: "A/B тест",
      navGroup: "ABTest"
    }
  },
  {
    path: "/quiz/setting/:id/analytics",
    component: navLayout,
    name: "analytics",
    meta: {
      layout: "navLayout",
      children: "quizSetting",
      nextChildren: "AnalyticsComponent",
      nameNav: "Статистика",
      navGroup: "analytics"
    }
  },
  {
    path: "/quiz/setting/:id/configuration",
    component: navLayout,
    meta: {
      layout: "navLayout",
      children: "quizSetting",
      nextChildren: "ConfigurationQuiz",
      nameNav: "Настройки",
      navGroup: "configuration"
    }
  },
  {
    path: "/quiz/setting/:id/questions",
    component: navLayout,
    meta: {
      layout: "navLayout",
      children: "quizSetting",
      nextChildren: "QuizQuestions",
      nameNav: "Вопросы",
      navGroup: "quiz"
    }
  },
  {
    path: "/policy",
    component: policyPage,
    meta: {
      layout: "default"
    }
  },
  {
    path: "/widget",
    component: WidgetComponent,
    meta: {
      layout: "default"
    }
  },
  {
    path: "/authorization",
    name: "authorization",
    component: startPage,
    meta: {
      layout: "defaultLayout",
      children: "AuthorizationComponents"
    }
  },
  {
    path: "/registration",
    name: "registration",
    component: startPage,
    meta: {
      layout: "defaultLayout",
      children: "RegistrationComponents"
    }
  },
  {
    path: "/registration-confirm",
    name: "registrationConfirm",
    component: startPage,
    meta: {
      layout: "defaultLayout",
      children: "RegistrationConfirmComponents"
    }
  },
  {
    path: "/user",
    component: navLayout,
    meta: {
      layout: "navLayout",
      children: "AccountComponent",
      navGroup: "user"
    },
    children: [
      {
        path: "integration",
        component: navLayout,
        meta: {
          layout: "navLayout",
          children: "IntegrationComponent",
          navGroup: "integration"
        }
      }
    ]
  },
  {
    path: "/setting",
    component: navLayout,
    meta: {
      layout: "navLayout",
      children: "ClinicComponent",
      navGroup: "setting"
    },
    children: [
      {
        path: "doctors",
        component: navLayout,
        meta: {
          layout: "navLayout",
          children: "DoctorsComponent",
          navGroup: "settingDoctors"
        }
      },
      {
        path: "services",
        component: navLayout,
        meta: {
          layout: "navLayout",
          children: "ServisesComponent",
          navGroup: "settingServices"
        }
      },
      {
        path: "application",
        component: navLayout,
        meta: {
          layout: "navLayout",
          children: "ApplicationComponent",
          navGroup: "settingApplication"
        }
      }
    ]
  }
];
const custopmRoutes = [
  {
    path: "/:id",
    component: quizPage,
    meta: {
      layout: "default"
    }
  },
  {
    path: "/",
    component: quizPage,
    meta: {
      layout: "default"
    }
  }
];

let preparationRouter = createRouter({
  history: createWebHistory(),
  routes: customDomein ? custopmRoutes : routes
});

function isPublicRoute(path: string): boolean {
  const publicPaths = [
    "/",
    "/policy",
    "/widget",
    "/authorization",
    "/registration",
    "/registration-confirm",
    "/test",
    "/seagull"
  ];

  if (publicPaths.includes(path)) {
    return true;
  }

  return (
    path.startsWith("/quiz/") &&
    !path.startsWith("/quiz/setting/") &&
    path.split("/").filter(Boolean).length === 2
  );
}

preparationRouter.beforeEach((to, from, next) => {
  if (
    !customDomein &&
    !isPublicRoute(to.path) &&
    !localStorage.getItem("keyUserAuth")
  ) {
    next({
      path: "/authorization",
      query: to.fullPath ? {redirect: to.fullPath} : undefined,
      replace: true
    });
    return;
  }

  const html = document.querySelector("html");
  if (!html) {
    next();
    return;
  }
  if (
    (to?.params?.id && to.fullPath.includes("/quiz/" + to.params.id)) ||
    to.fullPath.includes("seagull")
  ) {
    html.style.background = "white";
  } else {
    html.style.background = "var(--surface-base-color)";
  }
  next();
});

export const router = preparationRouter;
